export default "__VITE_ASSET__CXe6GSzw__"